import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/45.png';
import _imports_1 from '../../../assets/new/29.png';
const _withScopeId = n => (_pushScopeId("data-v-5a198002"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-5a198002>填写真实信息</div><div class=\"step\" data-v-5a198002><div data-v-5a198002>1.填写学校</div><img src=\"" + _imports_0 + "\" data-v-5a198002><div class=\"active\" data-v-5a198002>2.选择年级班级</div><img src=\"" + _imports_0 + "\" data-v-5a198002><div data-v-5a198002>3.填写姓名</div></div>", 2);
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "cells"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "年级", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_8 = {
  class: "left"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "班级", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
import { ref, onMounted, reactive, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
export default {
  __name: 'classMes_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const router = useRouter();
    const route = useRoute();
    const gradeName = ref("");
    const className = ref("");
    const gradePicker = ref(false);
    const classPicker = ref(false);
    const classData = reactive({
      data: []
    });
    const grade = [{
      name: "小一上 (0起点)",
      value: "X1s"
    }, {
      name: "小一下",
      value: "X1x"
    }, {
      name: "小二上",
      value: "X2s"
    }, {
      name: "小二下",
      value: "X2x"
    }, {
      name: "小三上",
      value: "X3s"
    }, {
      name: "小三下",
      value: "X3x"
    }, {
      name: "小四上",
      value: "X4s"
    }, {
      name: "小四下",
      value: "X4x"
    }, {
      name: "小五上",
      value: "X5s"
    }, {
      name: "小五下",
      value: "X5x"
    }, {
      name: "小六上",
      value: "X6s"
    }, {
      name: "小六下",
      value: "X6x"
    }, {
      name: "初一上",
      value: "C1s"
    }, {
      name: "初一下",
      value: "C1x"
    }, {
      name: "初二上",
      value: "C2s"
    }, {
      name: "初二下",
      value: "C2x"
    }, {
      name: "初三上",
      value: "C3s"
    }, {
      name: "初三下",
      value: "C3x"
    }, {
      name: "高一上",
      value: "G1s"
    }, {
      name: "高一下",
      value: "G1x"
    }, {
      name: "高二上",
      value: "G2s"
    }, {
      name: "高二下",
      value: "G2x"
    }, {
      name: "高三上",
      value: "G3s"
    }, {
      name: "高三下",
      value: "G3x"
    }, {
      name: "大一上",
      value: "B1s"
    }, {
      name: "大一下",
      value: "B1x"
    }, {
      name: "大二上",
      value: "B2s"
    }, {
      name: "大二下",
      value: "B2x"
    }, {
      name: "大三上",
      value: "B3s"
    }, {
      name: "大三下",
      value: "B3x"
    }, {
      name: "大四上",
      value: "B4s"
    }, {
      name: "大四下",
      value: "B4x"
    }, {
      name: "研一上",
      value: "Y1s"
    }, {
      name: "研一下",
      value: "Y1x"
    }, {
      name: "研二上",
      value: "Y2s"
    }, {
      name: "研二下",
      value: "Y2x"
    }, {
      name: "研三上",
      value: "Y3s"
    }, {
      name: "研三下",
      value: "Y3x"
    }, {
      name: "研四上",
      value: "Y4s"
    }, {
      name: "研四下",
      value: "Y4x"
    }];
    const getPeriod = computed(() => {
      if (formData.data.school_type === "X") return grade.filter(v => {
        return v.value[1] == "B" || v.value[0] === "X";
      });
      if (formData.data.school_type === "C") return grade.filter(v => {
        return v.value[0] === "C";
      });
      if (formData.data.school_type === "G") return grade.filter(v => {
        return v.value[0] === "G";
      });
      if (formData.data.school_type === "D") return grade.filter(v => {
        return v.value[0] == "B" || v.value[0] === "Y";
      });
      return [];
    });
    const formData = reactive({
      data: {}
    });
    const next = () => {
      console.log(formData.data);
      if (formData.data.grade_id && formData.data.class_id) {
        if (route.query.type) {
          router.push({
            name: "studentMes",
            params: {
              ...formData.data
            },
            query: {
              type: route.query.type
            }
          });
        } else {
          router.push({
            name: "studentMes",
            params: {
              ...formData.data
            }
          });
        }
      } else {
        ElMessage.error("请选择完整哦");
      }
    };
    const selectGrade = data => {
      console.log(data);
      gradeName.value = data.name;
      formData.data.grade_id = data.value;
      gradePicker.value = false;
    };
    const selectClass = data => {
      console.log(data);
      className.value = data.text;
      formData.data.class_id = data.value;
      classPicker.value = false;
    };
    onMounted(() => {
      console.log(route.params);
      if (Object.keys(route.params).length === 0) {
        router.push({
          name: "schoolMes"
        });
      }
      formData.data = {
        ...route.params
      };
      console.log(formData);
      if (formData.data.grade_id) {
        gradeName.value = grade.filter(item => item.value === formData.data.grade_id)[0].name;
      }
      for (let i = 1; i <= 40; i++) {
        classData.data.push({
          text: i + "班",
          value: i + ""
        });
      }
      if (formData.data.class_id !== "0") {
        className.value = classData.data.filter(item => item.value === formData.data.class_id + "")[0].text;
      }
    });
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[0] || (_cache[0] = $event => gradePicker.value = true)
      }, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createTextVNode(" " + _toDisplayString(gradeName.value), 1)]), _hoisted_7]), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[1] || (_cache[1] = $event => classPicker.value = true)
      }, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createTextVNode(" " + _toDisplayString(className.value), 1)]), _hoisted_10])]), _createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        onClick: next,
        style: {
          "width": "80%",
          "margin": "1rem auto"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("下一步")]),
        _: 1
      })])])], 2), _createVNode(_component_van_popup, {
        show: gradePicker.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => gradePicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "请选择年级",
          columns: getPeriod.value,
          onCancel: _cache[2] || (_cache[2] = $event => gradePicker.value = false),
          onConfirm: selectGrade,
          "columns-field-names": {
            text: 'name'
          }
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: classPicker.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => classPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "请选择班级",
          columns: classData.data,
          onConfirm: selectClass,
          onCancel: _cache[4] || (_cache[4] = $event => classPicker.value = false)
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};